import { render, staticRenderFns } from "./StoryblokCustomerValueProposition.vue?vue&type=template&id=aa310050&"
import script from "./StoryblokCustomerValueProposition.vue?vue&type=script&lang=ts&"
export * from "./StoryblokCustomerValueProposition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports